import {Component, OnDestroy, OnInit} from '@angular/core';
import { StateService } from "@uirouter/angular";
import { LastWeekSchedule } from 'src/app/model/last-week-schedule.model';
import { DatePipe } from '@angular/common';
import { DateHelpers, SessionService, User } from '@edl-development/edl-common';
import { Subscription } from 'rxjs';
import { multiFactor } from 'firebase/auth';
import { ModalService } from 'src/app/modals/modal.service';

@Component({
    selector: 'authenticated-header.',
    templateUrl: './authenticated-header.component.html',
    styleUrls: ['./authenticated-header.component.scss']
})
export class AuthenticatedHeaderComponent implements OnInit, OnDestroy {
    messagesParams: { page: number, start: string, end: string };
    datePipe = new DatePipe('en-US');

    user?: User;
    activeUserSub?: Subscription;
    isVolunteerEnabled?: boolean;

    constructor(
        private stateService: StateService,
        private sessionService: SessionService,
        private modalService: ModalService
    ) { }

    ngOnInit() {
        this.activeUserSub = this.sessionService.activeUser.subscribe((user: User) => {
            this.user = user;
            let mfad = this.sessionService.GetSessionValue('000MFAD');
            var AuthUser = this.sessionService.GetAuthApp().currentUser!;
            if(AuthUser){
              const multiFactorUser = multiFactor(AuthUser);
              let mfaMissing = multiFactorUser.enrolledFactors.length === 0;
              let sqMissing = !this.user.SQPresent;
              var isUA = this.stateService.current.name === 'public.user-agreement';

              if(this.user.MFAEnforced && (mfad == null || mfad == false) && (mfaMissing || sqMissing) && !isUA) {
                this.modalService.notifyOfMFAEnforcement(this.user, false)
                .then((result) => {
                  if (result) {
                    this.stateService.go('authenticated.users.user.edit', {userId: user?.UserID});
                  }
                }).catch(error => {});
                this.sessionService.SetSessionValue('000MFAD', true);
              }
            }

        });

        this.messagesParams = this.generateMessagesParams();
        this.isVolunteerEnabled = this.sessionService.PortalSettings.VolunteersEnabled;
    }

    ngOnDestroy(): void {
        this.activeUserSub?.unsubscribe();
    }

    private generateMessagesParams() {
        const lastWeekSchedule = new LastWeekSchedule();
        return {
            page: 1,
            start: this.datePipe.transform(DateHelpers.shortDateStringToDate(lastWeekSchedule.StartDate), 'MM/dd/yyyy'),
            end:this.datePipe.transform(DateHelpers.shortDateStringToDate(lastWeekSchedule.EndDate),'MM/dd/yyyy'),
        }
    }

    public logout() {
        this.stateService.go('public.logout');
    }

    public showSupportInfoModal() {
        this.modalService.info('Support', 'Please contact your district if you have any questions.');
    }
}
